var map = {
	"./featured-title.de-CH.json": 795,
	"./featured-title.de-DE.json": 796,
	"./featured-title.en-CA.json": 797,
	"./featured-title.en-GB.json": 798,
	"./featured-title.en-IN.json": 799,
	"./featured-title.en-ME.json": 800,
	"./featured-title.en-US.json": 801,
	"./featured-title.es-EM.json": 802,
	"./featured-title.es-ES.json": 803,
	"./featured-title.fr-BE.json": 804,
	"./featured-title.fr-CA.json": 805,
	"./featured-title.fr-CH.json": 806,
	"./featured-title.nl-BE.json": 807,
	"./featured-title.nl-NL.json": 808,
	"./featured-title.pl-PL.json": 809,
	"./featured-title.pt-BR.json": 810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;